import React, { useState } from "react";
import Input from "./Input";

interface NumberInputProps extends Omit<React.ComponentProps<"input">, "type"> {
    label: string;
    description?: string;
    error?: string;
}

export default function NumberInput(
    {
        label,
        description,
        error,
        className,
        ...props
    }: Readonly<NumberInputProps>) {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className="flex flex-col gap-1 w-full">
            <div className="relative w-fit">
                <label
                    className="text-sm font-medium"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    {label}
                </label>
                {showTooltip && description && (
                    <div
                        className="absolute z-[1000] bg-black/85 text-white rounded px-3 py-2 text-sm leading-relaxed pointer-events-none whitespace-normal max-w-xs left-0 bottom-full mb-1 w-max">
                        {description}
                    </div>
                )}
            </div>
            <Input
                type="number"
                step="1"
                className={`w-full bg-white ${error ? "border-red-500" : ""} ${className || ""}`}
                placeholder={label}
                onKeyDown={(e) => {
                    if (e.key === '.' || e.key === ',') {
                        e.preventDefault();
                    }
                }}
                {...props}
            />
            {error && <span className="text-red-600 text-xs mt-1">{error}</span>}
        </div>
    );
}
